import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

export interface AddressSuggestion {
    DPID: number;
    SourceDesc: string;
    FullAddress: string;
}

@Injectable()
export class AddressSuggestionsService {

    suggestions$: BehaviorSubject<any[]>;
    detail$: BehaviorSubject<any[]>;

    constructor(private httpClient: HttpClient) {
        this.suggestions$ = new BehaviorSubject<AddressSuggestion[]>([]);
        this.detail$ = new BehaviorSubject<any[]>([]);
    }

    getSuggesstions(q: string, type: string = 'All') {
        const max = 5;
        const apiBaseUrl = `${location.protocol}//address.nzpost.co.nz/api/suggest.json`;
        const url = `${apiBaseUrl}?max=${max}&public_api_key=${environment.nzPostPublicApiKey}&q=${q}&type=${type}`;
        return this.httpClient.jsonp(url, 'callback')
            .subscribe(
                (data: any) => this.suggestions$.next(!!data.success ? data.addresses : []),
                _ => [this.suggestions$.next([])]);
    }

    getDetail(dpid: number, type: string = 'All') {
        const max = 5;
        const apiBaseUrl = `${location.protocol}//address.nzpost.co.nz/api/details`;
        const url = `${apiBaseUrl}?&public_api_key=${environment.nzPostPublicApiKey}&dpid=${dpid}&type=${type}`;
        return this.httpClient.jsonp(url, 'callback')
            .subscribe(
                (data: any) => this.detail$.next(!!data.success ? data.details : []),
                _ => [this.detail$.next([])]);
    }

    getDetail$(dpid: string, type: string = 'All') {
        const apiBaseUrl = `${location.protocol}//address.nzpost.co.nz/api/details`;
        const url = `${apiBaseUrl}?&public_api_key=${environment.nzPostPublicApiKey}&dpid=${dpid}&type=${type}`;
        return this.httpClient.jsonp(url, 'callback');
    }

    clearData() {
        this.suggestions$.next([]);
        this.detail$.next([]);
    }

}
